import connect from './connect';

export { DocumentRemindSection } from './DocumentRemindSection';

export default connect;
